import { ref, computed } from 'vue';

export function useParseDiscount(discount: string) {
  const isPercent = ref<boolean>(false);
  const isRuble = ref<boolean>(false);
  const isText = ref<boolean>(false);

  const parsedDiscount = computed(() => {
    const percentRe = /(\d+)\s*([,.]\d+)?%$/;
    const rubleRe = /([\d\s*]+)\s*\u20BD$/u;
    const hasNumberRe = /\d+/;
    if (discount && percentRe.test(discount)) {
      isPercent.value = true;
      return discount.match(percentRe)![1];
    } else if (discount && rubleRe.test(discount)) {
      isRuble.value = true;
      return discount.match(rubleRe)![1].replace(/\s+/g, '');
    } else if (discount && !hasNumberRe.test(discount)) {
      isText.value = true;
    }
    return discount;
  });

  return {
    parsedDiscount,
    isRuble,
    isText,
    isPercent,
  };
}
